import { createEvent, createStore, sample } from '@lib/state-engine';
import { createUuid } from '@lib/uuid';

export const showInformer = createEvent<InformerOptions>();
export const $informers = createStore<Informers>({});
export const deleteInformer = createEvent<string>();

sample({
  clock: showInformer,
  source: $informers,
  fn: (informers, opts) => {
    const key = createUuid();

    if (opts.timeout) {
      setTimeout(() => deleteInformer(key), opts.timeout);
    }

    return {
      ...informers,
      [key]: {
        ...opts,
        key,
      },
    };
  },
  target: $informers,
});

sample({
  clock: deleteInformer,
  source: $informers,
  filter: (informers, id) => Boolean(informers[id]),
  fn: (informers, id) => {
    const newInformers = { ...informers };
    delete newInformers[id];
    return newInformers;
  },
  target: $informers,
});

type InformerOptions = {
  title: number | string;
  timeout?: number;
  content?: string | React.ReactNode;
  status?: 'success' | 'system' | 'alert' | 'warning';
};
type Informer = InformerOptions & { key: string };
type Informers = {
  [key: string]: Informer;
};
